import CONSTANTS from "../CONSTANTS";

export const actionResetApp = () => ({
  type: CONSTANTS.RESET_APP,
});
